import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAllCurrencies1 } from "@/redux/actions/FetchCoinLists";
import {
  getTopFiveBalance,
  getResultKYC,
  getUserPendingBalanceWebapp,
} from "../../../../utils/services/user.service";

export const useDashboardData = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [kycStatus, setKycStatus] = useState("");
  const [sendAmount, setSendAmount] = useState(null);
  const [receiveAmount, setReceiveAmount] = useState(null);
  const [contractAmount, setContractAmount] = useState(null);
  const [walletData, setWalletData] = useState(null);
  const [onchainWalletData, setOnchainWalletData] = useState(null);
  const [bankData, setBankData] = useState(null);
  const [pendingBalance, setPendingBalance] = useState([]);

  // Fetch KYC status
  useEffect(() => {
    const fetchKYC = async () => {
      try {
        const res = await getResultKYC();
        setKycStatus(res?.data?.verifications[0]?.status || "");
      } catch (error) {
        console.error("Error fetching KYC:", error);
      }
    };
    fetchKYC();
  }, []);

  // Fetch dashboard data
  useEffect(() => {
    setIsLoading(true);

    // Fetch virtual wallet data (internal wallet)
    dispatch(fetchAllCurrencies1());

    // Fetch wallet balances (onchain, otc)
    getTopFiveBalance()
      .then((res) => {
        setWalletData(res.data);
        setOnchainWalletData(res?.data?.onchain?.[0]?.topBalances || []);
        if (res?.data?.bank) {
          setBankData(res.data.bank);
        } else if (res?.data?.striga) {
          setBankData(res.data.striga);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });

    // Fetch pending balance (upcoming)
    getUserPendingBalanceWebapp()
      .then((res) => {
        setPendingBalance(res?.data?.data || []);
      })
      .catch(() => {
        setPendingBalance([]);
      });

    dispatch(fetchAllCurrencies1());
  }, [dispatch]);

  return {
    isLoading,
    kycStatus,
    sendAmount,
    receiveAmount,
    contractAmount,
    walletData,
    onchainWalletData,
    bankData,
    pendingBalance,
    setPendingBalance,
    setWalletData,
    setOnchainWalletData,
  };
};

